export class UBXButton {
    constructor(
        public name: string,
        public type: string,
        public color: string,
    ) {}
}
